import type { EnvelopeBudget } from '@/api/envelopes';

/** The entry in effect on `today`: the newest one from on or before it (the list is newest first). */
export function budgetInEffect(
  budgets: readonly EnvelopeBudget[],
  today: string,
): EnvelopeBudget | null {
  return budgets.find((budget) => budget.effectiveFrom <= today) ?? null;
}
